import get from 'lodash/get';
import moment from 'moment';

type DOCUMENT_TYPE =
    | 'documents_annual_charge'
    | 'documents_notice'
    | 'documents_parking_plan'
    | 'documents_floor_plan'
    | 'documents_global_plan'
    | 'documents_booking_contract'
    | 'documents_works_contract'
    | 'documents_commercial_brochure'
    | 'documents_management_brochure'
    | 'documents_rental_agreement'
    | 'documents_general_assembly'
    | 'documents_notice_pro'
    | 'documents_autres';


const documentTypes: { [id in DOCUMENT_TYPE]: string } = {
    documents_annual_charge: 'Décompte charge et 3 AG (Bail Co.)',
    documents_notice: 'Notice descriptive',
    documents_notice_pro: 'Notice descriptive Local Pro',
    documents_parking_plan: 'Plan des PK, Gge, Cave',
    documents_floor_plan: 'Plan des étages',
    documents_global_plan: 'Doc Contrat Résa',
    documents_booking_contract: 'Plan de masse',
    documents_works_contract: 'Plaquette commerciale',
    documents_commercial_brochure: 'Marché de travaux (Immo. Ancien)',
    documents_management_brochure: "Relevé de gérance (Bail Co.)",
    documents_rental_agreement: 'Bail/relève gérance (Bail Co.)',
    documents_general_assembly: 'Assemblée(s) générale(s) (Bail Co.)',
    documents_autres: 'Autres: Non Classé(s)',
};

function formatDocumentType(value: string): string {
    return get(documentTypes, value, value);
}

function formatDocumentTypeFileName(bookingCode: string, value: string): string {
    return `${bookingCode}_${get(documentTypes, value, value)}_${moment().format('DDMMYYYY')}`;
}

export { DOCUMENT_TYPE, documentTypes, formatDocumentType, formatDocumentTypeFileName };
